import { Platform } from '@angular/cdk/platform';
import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { catchError, EMPTY, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const cookieService = inject(CookieService);
    const authService = inject(AuthService);
    const isServer = !inject(Platform).isBrowser;
    const { apiUrl, cookieName } = environment;
    const { url } = req;
    const excludeControllers = ['auth'];

    if (req.url.includes(apiUrl)) {
        const token = cookieService.get(cookieName);
        return next(
            req.clone({
                withCredentials: true,
                headers: req.headers.set('Authorization', 'Bearer ' + (token || '')),
            })
        ).pipe(
            catchError((error) => {
                const { status } = error;
                const apiURL = new URL(url);
                const [_1, controller] = apiURL.pathname.split('/').filter((v) => v);
                const unauthorized = status === HttpStatusCode.Unauthorized;
                if (unauthorized) {
                    authService.updateSession(null);
                }
                const isExcluded = excludeControllers.includes(controller.toLowerCase());
                const needSignIn = unauthorized && !isExcluded && !isServer;
                if (!needSignIn) {
                    return throwError(() => error);
                }
                return authService.openSignInDialog().pipe(
                    switchMap((result) => {
                        if (!result) {
                            return EMPTY;
                        }
                        return next(
                            req.clone({
                                withCredentials: true,
                                headers: req.headers.set(
                                    'Authorization',
                                    'Bearer ' + (cookieService.get(cookieName) || '')
                                ),
                            })
                        );
                    })
                );
            })
        );
    }
    return next(req);
};
